import {
  Box,
  CircularProgress,
  Divider,
  FormControlLabel,
  styled,
  Typography,
} from '@mui/material';

export const StyledContentBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(90),
  padding: theme.spacing(4),
  overflow: 'auto',
  flex: 1,
  height: 'calc(100% - 90px)',
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledForm = styled('form')(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0, 2),
}));

export const StyledCheckboxGroup = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledFormControl = styled(FormControlLabel)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),
  '& span': {
    fontWeight: 'bold',
  },
}));

export const StyledActionsBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
  flexDirection: 'row',
  marginTop: 'auto',
}));

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  display: 'block',
  margin: theme.spacing(20, 'auto'),
}));

export const StyledErrorMessage = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));
